import { fitFixedDurationInBounds } from '@app/core/range';
import { roundToSeconds } from '@mi-front/core';
import { CalculateAllowedRange } from '../range/calculate-allowed-range';

const HOUR_MS = 60 * 60 * 1000;

export interface GetGoToTimeStreamRangeOptions {
  /** Target timestamp in ms. The computed range will be 1 hour long starting at this time (rounded to seconds). */
  ts: number;
  /** Allowed [from, to] bounds. The returned range is always enclosed within this range. */
  streamableRange: CalculateAllowedRange;
}

export interface GoToTimeStreamRange {
  from: number;
  to: number;
}

/**
 * Computes the stream range (from, to) for "go to time" navigation.
 * Returns a 1-hour range starting at ts (rounded to seconds), enclosed in streamableRange.
 * Delegates to fitFixedDurationInBounds with anchor 'start'.
 */
export function getGoToTimeStreamRange(
  options: GetGoToTimeStreamRangeOptions,
): GoToTimeStreamRange {
  const { ts, streamableRange } = options;
  const startTs = roundToSeconds(ts);
  return fitFixedDurationInBounds(startTs, HOUR_MS, streamableRange, 'start');
}
